import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'replacespaces'})
export class ReplaceSpacePipe implements PipeTransform {
    transform(value: string): string {
        return value.replace(/\u00a0/g, ' ');
    }
}
